module.exports = __webpack_public_path__ + "img/FaceAI-mockup3.a9e4d4ab.png";